module.exports = {
  templateUrl: '/angular_pages/Components/CatalogFilterComponent/CatalogFilterComponentTemplate.tpl?' + __webpack_hash__,
  controller: require("../controllers/CatalogFilterComponentController"),
  controllerAs: 'catalogFilterCtrl',
  bindings: {
    catalogId: '<'
  },
}